import type { DemoScenarioResolved } from 'tio-data/demo/types';
import type { DemoFixtureIdentity, DemoProductConfig, DemoScenario } from 'tio-employee/demo/types';
import {
  IN_PROGRESS_TAS_FETCH_MATCHERS,
  buildInProgressTasFetchMatchers,
  buildInProgressTasMatchers,
} from 'tio-employee/demo/products/tas-fixtures';

/**
 * Builds the demo matchers + fixtures for the Tuition Assistance product, so
 * the store-routed TAS pages render demo data through their normal store calls.
 * Ships the in-progress scenario; other scenario ids fall through to the
 * real network until authored. Employer/employee names derive from the shared
 * fixture identity so TAS surfaces agree with the session identity, and the
 * application fixture is shaped by the selected TA payment model so the admin
 * drill-ins (approval page, application show) reflect CourseCash/deferral.
 */
export function buildTasDemo(
  config: Extract<DemoProductConfig, { kind: 'tas' }>,
  _scenario: DemoScenario,
  identity: DemoFixtureIdentity
): DemoScenarioResolved {
  if (config.scenarioId === 'in-progress') {
    return {
      matchers: buildInProgressTasMatchers(identity, config.taPaymentModelId),
      seed: [],
      fetchMatchers: [
        ...IN_PROGRESS_TAS_FETCH_MATCHERS,
        ...buildInProgressTasFetchMatchers(identity, config.taPaymentModelId),
      ],
    };
  }
  return { matchers: [], seed: [] };
}
